<sl-page-header header="Import Contacts" sticky i18n-header></sl-page-header>
<sl-layout>
    <app-csv-importer [fields]="fields" [dataImporter]="dataImporter" [dataBuilder]="dataBuilder" (step)="onStep($event)"></app-csv-importer>
</sl-layout>